import eth1 from '../../Attachments/Image/EthData/I1.png';
import eth2 from '../../Attachments/Image/EthData/I2.png';
import eth3 from '../../Attachments/Image/EthData/I3.png';
import eth4 from '../../Attachments/Image/EthData/I4.png';
import eth5 from '../../Attachments/Image/EthData/I5.png';
import eth6 from '../../Attachments/Image/EthData/I6.png';
import eth7 from '../../Attachments/Image/EthData/I7.png';
import eth8 from '../../Attachments/Image/EthData/I8.png';
import eth9 from '../../Attachments/Image/EthData/I9.png';
import eth10 from '../../Attachments/Image/EthData/I10.png';
import eth11 from '../../Attachments/Image/EthData/I11.png';
import eth12 from '../../Attachments/Image/EthData/I12.png';
import eth13 from '../../Attachments/Image/EthData/I13.png';
import eth14 from '../../Attachments/Image/EthData/I14.png';
import eth15 from '../../Attachments/Image/EthData/I15.png';
import eth16 from '../../Attachments/Image/EthData/I16.png';
import eth17 from '../../Attachments/Image/EthData/I17.png';
import eth18 from '../../Attachments/Image/EthData/I18.png';



const EthData = [
    {
        src: eth1,
        alt: "#1",
        price: "3.25",
    },
    {
        src: eth2,
        alt: "#2",
        price: "1.67",
    },
    {
        src: eth3,
        alt: "#3",
        price: "2.12",
    },
    {
        src: eth4,
        alt: "#4",
        price: "4.21",
    },
    {
        src: eth5,
        alt: "#5",
        price: "2.34",
    },
    {
        src: eth6,
        alt: "#6",
        price: "2.14",
    },
    {
        src: eth7,
        alt: "#7",
        price: "4.24",
    },
    {
        src: eth8,
        alt: "#8",
        price: "1.43",
    },
    {
        src: eth9,
        alt: "#9",
        price: "2.53",
    },
    {
        src: eth10,
        alt: "#10",
        price: "1.57",
    },
    {
        src: eth11,
        alt: "#11",
        price: "1.55",
    },
    {
        src: eth12,
        alt: "#12",
        price: "2.65",
    },
    {
        src: eth13,
        alt: "#13",
        price: "3.15",
    },
    {
        src: eth14,
        alt: "#14",
        price: "1.64",
    },
    {
        src: eth15,
        alt: "#15",
        price: "1.55",
    },
    {
        src: eth16,
        alt: "#16",
        price: "2.65",
    },
    {
        src: eth17,
        alt: "#17",
        price: "3.15",
    },
    {
        src: eth18,
        alt: "#18",
        price: "1.64",
    },
     {
        src: eth1,
        alt: "#1",
        price: "3.25",
    },
    {
        src: eth2,
        alt: "#2",
        price: "1.67",
    },
    {
        src: eth3,
        alt: "#3",
        price: "2.12",
    },
    {
        src: eth4,
        alt: "#4",
        price: "4.21",
    },
    {
        src: eth5,
        alt: "#5",
        price: "2.34",
    },
    {
        src: eth6,
        alt: "#6",
        price: "2.14",
    },
    {
        src: eth7,
        alt: "#7",
        price: "4.24",
    },
    {
        src: eth8,
        alt: "#8",
        price: "1.43",
    },
    {
        src: eth9,
        alt: "#9",
        price: "2.53",
    },
    {
        src: eth10,
        alt: "#10",
        price: "1.57",
    },
    {
        src: eth11,
        alt: "#11",
        price: "1.55",
    },
    {
        src: eth12,
        alt: "#12",
        price: "2.65",
    },
    {
        src: eth13,
        alt: "#13",
        price: "3.15",
    },
    {
        src: eth14,
        alt: "#14",
        price: "1.64",
    },
    {
        src: eth15,
        alt: "#15",
        price: "1.55",
    },
    {
        src: eth16,
        alt: "#16",
        price: "2.65",
    },
    {
        src: eth17,
        alt: "#17",
        price: "3.15",
    },
    {
        src: eth18,
        alt: "#18",
        price: "1.64",
    },
];

export default EthData;